import styled from '@emotion/styled';
import { palette, spacing } from 'theme';

export const Header = styled.div({
  backgroundColor: palette.neutral[150],
  paddingBlockStart: `clamp(${spacing[12]}, 2vw, ${spacing[28]})`,
  paddingBlockEnd: spacing[16],

  '& > *': {
    width: '100%',
    maxWidth: '700px',
    marginInline: 'auto',
    paddingInline: spacing[8],
  },
});

export const Body = styled.div({
  height: '0px',
  flex: '1 1 auto',
  overflow: 'auto',
  paddingBlockStart: spacing[12],

  // Table Scrollbar styling
  scrollbarWidth: 'thin',
  scrollbarColor: palette.neutral[400],

  // Works on Chrome, Edge, and Safari
  '&::-webkit-scrollbar': {
    width: '4px',
    height: '4px',
  },

  '&::-webkit-scrollbar-thumb': {
    background: palette.neutral[300],
    borderRadius: '4px',
  },

  '&:hover': {
    '&::-webkit-scrollbar-thumb': {
      background: palette.neutral[400],
      bordeRadius: '4px',
    },
  },
});

export const InnerBodyWrapper = styled.div({
  width: '100%',
  maxWidth: '700px',
  paddingInline: spacing[8],
  marginInline: 'auto',
});
